import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';
import COLORS from '@ui-component-library/styles/colors';
import { SUMMARY_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Container: styled.div<{ color?: string }>`
    ${SUMMARY_RESET}

    display: flex;
    flex-direction: column;
    gap: ${SPACING.size16};
    padding: ${SPACING.size16};
    border-radius: 8px;
    background-color: ${({ color }) =>
      COLORS[color as keyof typeof COLORS] || '#faf9f8'}; /* FIXME: Update COLORS  */
    border: 1px solid #e6e6e8; /* FIXME: Update COLORS  */
    width: 100%;
  `,

  Title: styled.h3`
    ${TYPOGRAPHY.labelLargeMedium}
    color: ${COLORS['charcoal-500']};
  `,

  Item: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${SPACING.size20};
    align-items: center;
  `,

  ItemLabel: styled.span`
    ${TYPOGRAPHY.labelMediumRegular}
    color: ${COLORS['pebble-500']};
    hyphens: auto;
  `,

  ItemValue: styled.span`
    ${TYPOGRAPHY.labelMediumMediumDense}
    color: ${COLORS['charcoal-500']};
    white-space: nowrap;
    text-align: right;
  `,

  Total: styled.div`
    border-top: 1px solid #e6e6e8;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${SPACING.size20};
    padding-top: ${SPACING.size16};
  `,

  TotalValueWrapper: styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: end;
  `,

  TotalLabel: styled.span`
    ${TYPOGRAPHY.labelLargeMedium}
    color: ${COLORS['pebble-500']};
    hyphens: auto;
  `,

  TotalValue: styled.span`
    ${TYPOGRAPHY.labelMediumMediumDense}
    color: ${COLORS['charcoal-500']};
    white-space: nowrap;
  `,

  TotalSubValue: styled.span`
    ${TYPOGRAPHY.labelXtraSmallRegular}
    color: ${COLORS['charcoal-500']};
  `
};
